import { Form } from 'factorial-form'
import {
  NewCustomTablePageSchemaFieldFragment,
  NewCustomTablePageSchemaFragment,
} from 'generated/resources/graphql'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type Resource from 'modules/custom_resources/store/models/customResources/Resource'
import type Value from 'modules/custom_resources/store/models/customResources/Value'

import coerceValueFromType from './coerceValueFromType'
import getValueType from './getValueType'

interface Props {
  schema?: NewCustomTablePageSchemaFragment
  field: NewCustomTablePageSchemaFieldFragment
  resource?: Resource | null | undefined
  currentValue?: Value
}

// TODO: check type after TS migration
// type FormProps = {
//   field_id: number,
//   field_type: string,
//   resource_id?: number,
//   editable: boolean,
//   mandatory: boolean,
//   name: string,
//   visible: boolean,
//   value: string | number | null | boolean | Array<string>
// }
const createForm = ({ schema, field, resource, currentValue }: Props): Form => {
  const dataValue = (): Record<string, any> => {
    if (!currentValue) {
      if (schema?.effectiveAtId === field.id) {
        return {
          value: dateToString(moment(), 'backend'),
        }
      } else {
        return {}
      }
    }

    return {
      value: coerceValueFromType(field, currentValue),
    }
  }

  const name =
    schema?.effectiveAtId === field.id
      ? i18n.t('custom_resources.schema.effective_at_label')
      : field.labelText

  console.log('options', field.options)

  const data = {
    field_id: field.id,
    field_type: field.fieldType,
    // TODO: An schema can have multiple resources for the same attachable (being defined)
    resource_id: resource?.attributes.id,
    editable: field.editable,
    installed: true,
    mandatory: field.required,
    choice_options: field.options ?? [],
    min_value: field.minValue ?? 0,
    max_value: field.maxValue ?? 10,
    name: name,
    visible: true,
    ...dataValue(),
  }

  return new Form(data, {
    field_id: 'number',
    field_type: 'string',
    resource_id: 'number',
    editable: 'boolean',
    mandatory: 'boolean',
    name: 'string',
    installed: 'boolean',
    choice_options: 'string',
    min_value: 'number',
    max_value: 'number',
    value: getValueType(field.fieldType),
    visible: 'boolean',
  })
}

export default createForm
